// src/pages/ResetPassword.jsx
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'
import { redirectByRole } from '../App'

export default function ResetPassword() {
  const nav = useNavigate()
  const [ready, setReady] = useState(false)
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [ok, setOk] = useState(false)

  // 메일 링크로 진입 시, supabase가 세션을 구성해 줌.
  // getUser() 가 가능해질 때까지 대기
  useEffect(() => {
    let mounted = true
      ; (async () => {
        const { data: { user } } = await supabase.auth.getUser()
        if (mounted) setReady(!!user)
      })()

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setReady(!!session?.user)
    })
    return () => sub.subscription.unsubscribe()
  }, [])

  async function onSubmit(e) {
    e.preventDefault()
    setError('')
    if (!password || password.length < 6) {
      setError('비밀번호는 6자 이상이어야 합니다.')
      return
    }
    if (password !== confirm) {
      setError('비밀번호 확인이 일치하지 않습니다.')
      return
    }
    try {
      const { error: err } = await supabase.auth.updateUser({ password })
      if (err) throw err
      setOk(true)
      // 새 비밀번호 설정 후 역할별 이동
      await redirectByRole(nav)
    } catch (e) {
      setError(e.message || '비밀번호 변경 실패')
    }
  }

  if (!ready) {
    return <div className="max-w-md mx-auto text-sm text-gray-600">세션 확인 중…</div>
  }

  return (
    <div className="max-w-md mx-auto">
      <h1 className="text-xl font-bold mb-4">새 비밀번호 설정</h1>
      <div className="rounded-2xl border bg-white p-4">
        <form onSubmit={onSubmit} className="grid gap-3">
          <input
            className="input"
            type="password"
            placeholder="새 비밀번호(6자 이상)"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <input
            className="input"
            type="password"
            placeholder="새 비밀번호 확인"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
          />
          {error && <div className="text-sm text-rose-600">{error}</div>}
          <button className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700" type="submit">
            변경
          </button>
        </form>
      </div>
    </div>
  )
}
